import { useEffect, useState } from "react";

import { FieldFilterType } from "../../../base/types";
import { INotification } from "./INotification";
import { useAuth } from "../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../services/data/tableDataApi";

export const useNotification = (notificationIds?: string[]) => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [records, setRecords] = useState<INotification[]>([]);

    useEffect(() => {
        if (!notificationIds || notificationIds.length === 0) return;
        getNotifications(notificationIds);
        // eslint-disable-next-line
    }, [user, notificationIds]);

    const getNotifications = (notificationIds: string[]): Promise<INotification[]> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.');
        }

        const fetchRecordsPromises = notificationIds.map(notificationId =>
            getRecords({
                userId: user?.userId || '',
                portalId: siteId || '',
                tableId: "slcm_notification",
                fieldList: ["slcm_name", "slcm_message", "slcm_notificationid"],
                filters: [{
                    group: 0, filters: [
                        { field: "slcm_notificationid", type: FieldFilterType.Const, value: notificationId },
                    ]
                }]
            })
                .unwrap()
        );

        return Promise.all(fetchRecordsPromises)
            .then(results => {
                const combinedRecords = results.flatMap(data =>
                    data.records.map<INotification>(p => ({
                        name: p["slcm_name"],
                        message: p["slcm_message"],
                        notificationId: p["slcm_notificationid"],
                    }))
                );

                setRecords(combinedRecords);
                return Promise.resolve(combinedRecords);
            });
    };

    return { records };
};

